class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends HTMLElement {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.toggle = this.querySelector('.header__menu-toggle');
    this.submenu = this.querySelector('.list-menu--disclosure');
    this.isOpen = false;
    
    if (this.toggle && this.submenu) {
      // Force close menu on initialization
      this.forceClose();
      
      this.toggle.addEventListener('click', this.handleToggleClick.bind(this));
      this.addEventListener('focusout', this.handleFocusOut.bind(this));
      
      // Close on escape key
      this.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.isOpen) {
          this.close();
          this.toggle.focus();
        }
      });
      
      // Close on outside click
      document.addEventListener('click', (e) => {
        if (this.isOpen && !this.contains(e.target)) {
          this.close();
        }
      });
      
      // Close menu when clicking any link in the submenu
      const submenuLinks = this.submenu.querySelectorAll('a');
      submenuLinks.forEach(link => {
        link.addEventListener('click', (e) => {
          // Close immediately
          this.forceClose();
        });
      });
      
      // Close menu when page visibility changes
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') {
          this.forceClose();
        }
      });
      
      // Close menu on page show (back/forward navigation)
      window.addEventListener('pageshow', () => {
        this.forceClose();
      });
    }
  }
  
  forceClose() {
    this.isOpen = false;
    this.submenu.classList.remove('is-open');
    this.toggle.setAttribute('aria-expanded', 'false');
    if (this.header) {
      this.header.preventHide = false;
    }
  }

  handleToggleClick(e) {
    e.preventDefault();
    e.stopPropagation();
    
    // Close other open menus
    if (!this.isOpen) {
      this.closeOtherMenus();
    }
    
    if (this.isOpen) {
      this.close();
    } else {
      this.open();
    }
  }

  handleFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) {
        this.close();
      }
    }, 100);
  }

  closeOtherMenus() {
    const allMenus = document.querySelectorAll('header-menu');
    allMenus.forEach(menu => {
      if (menu !== this && menu.isOpen) {
        menu.close();
      }
    });
  }

  open() {
    this.isOpen = true;
    this.submenu.classList.add('is-open');
    this.toggle.setAttribute('aria-expanded', 'true');
    
    if (this.header) {
      this.header.preventHide = true;
      
      if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') === '') {
        document.documentElement.style.setProperty(
          '--header-bottom-position-desktop',
          `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
        );
      }
    }
  }

  close() {
    this.isOpen = false;
    this.submenu.classList.remove('is-open');
    this.toggle.setAttribute('aria-expanded', 'false');
    
    if (this.header) {
      this.header.preventHide = false;
    }
  }
}

customElements.define('header-menu', HeaderMenu);
